import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import LoadingButton from "./loadingButton";

function CustomModal({
  show,
  handleClose,
  title,
  body,
  isLoading,
  handleSubmit,
  name
}) {
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <LoadingButton isLoading={isLoading} onChange={handleSubmit}>
            {name}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CustomModal;
